import React from 'react'
import PropTypes from 'prop-types'
import ContentContainer from 'components/ContentContainer'

const CreateTokenContentContainer = ({ children }) => (
  <ContentContainer top="calc(23vh - 40px)">
    {children}
  </ContentContainer>
)

CreateTokenContentContainer.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
}

export default CreateTokenContentContainer
